(function () {
  function reveal() {
    var heroes = document.querySelectorAll('[data-flavor-hero]');
    if (heroes.length === 0) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      heroes.forEach(function (h) {
        h.classList.add('in-view');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.35 }
    );
    heroes.forEach(function (h) {
      io.observe(h);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
